import { OnboardingHeader } from "./OnboardingHeader";
import { useOnboarding } from "../../OnboardingContext";
import { useOnboardingStep } from "../../hooks/useOnboardingStep";

export const OnboardingHeaderContainer = () => {
  const { organization } = useOnboarding();

  const { currentStep } = useOnboardingStep();

  if (!organization) return null;

  const isInverted = ["intro", "matching-intro", "quiz"].includes(
    currentStep?.name || ""
  );

  return (
    <OnboardingHeader
      organizationName={organization?.name}
      isInverted={isInverted}
    />
  );
};

export default OnboardingHeaderContainer;
